const showCaNames = (map, show) => {
    map.setLayoutProperty('ca-labels', "visibility", show ? "visible": "none")
    map.setLayoutProperty('bloomsbury-label', "visibility", show ? "visible": "none")  
}

export default showCaNames;